<template>
    <div>
        <Breadcrumb section-name="Raw Material Profit" :breadcrumb="breadCrumb" :btn-name="'Add '+ breadCrumb"
                    :click-action="rawMaterialProfitAdd"></Breadcrumb>
        <div class="col-12">
            <div class="card mb-0">
                <div class="card-body">
                    <Table :tbl-data="table" :param="param"></Table>
                </div>
            </div>
        </div>
        <confirm-dialogue ref="confirmDialogue"></confirm-dialogue>
    </div>
</template>

<script>
import Breadcrumb from "../Common/Breadcrumb";
import ApiService from "../../Services/ApiService";
import PrintService from "../../Services/PrintService";
import ApiRoutes from "../../Services/ApiRoutes";
import Table from "../Common/Table";
import DownloadService from "../../Services/DownloadService";
import ConfirmDialogue from "../Common/confirmPopup/ConfirmDialogue";
export default {
    components: {Table, Breadcrumb, ConfirmDialogue},
    data() {
        return {
            breadCrumb: [],
            param: {
                keyword: '',
                limit: 10,
                order_by: 'id',
                order_mode: 'DESC',
                page: 1,
            },
            table: {
                total: {
                    colspan: 9,
                    amount: ''
                },
                columns: [
                    {type: 'text', key: 'date', label: 'Date', sortable: true},
                    {type: 'text', key: 'customer_name', label: 'Customer Name', sortable: true},
                    {type: 'text', key: 'raw_material_name', label: 'Product Name', sortable: true},
                    {type: 'text', key: 'unit_name', label: 'Unit', sortable: true},
                    {type: 'text', key: 'quantity', label: 'Quantity', sortable: true},
                    {type: 'text', key: 'unit_purchase_price', label: 'Unit Purchase Price', sortable: true},
                    {type: 'text', key: 'unit_sales_price', label: 'Unit Sales Price', sortable: true},
                    {type: 'text', key: 'purchase_price', label: 'Purchase Price', sortable: true},
                    {type: 'text', key: 'sales_price', label: 'Sales Price', sortable: true},
                    {type: 'text', key: 'profit', label: 'Profit', sortable: true},
                    {type: 'text', key: 'remarks', label: 'remarks', sortable: true},
                ],
                rows: [],
                row_actions: [
                    {name: 'print', type: 'action', label: 'bx bx-printer', color: 'btn-info', loading:false},
                    {name: 'edit', type: 'action', label: 'bx bx-pencil', color: 'btn-info'},
                    {name: 'delete', type: 'action', label: 'bx bx-trash', color: 'btn-gradient-danger'}
                ],
                tableIconAction: (data) => {
                    this.tableIconAction(data.row_action, data.row_data, data.row_index);
                },
                tableLoading: false,
                paginateData: {},
                updatePagination: (page) => {
                    this.list(page)
                },
                updateFilter: (param) => {
                    this.param = param
                    this.list()
                },
                dropdown: [

                ],
                download: [
                    // {
                    //     icon: 'xls',
                    //     loading: false,
                    //     action: () => {
                    //         this.downloadFile('xls')
                    //     }
                    // },
                    // {
                    //     icon: 'pdf',
                    //     loading: false,
                    //     action: () => {
                    //         this.downloadFile('pdf')
                    //     }
                    // }
                ],
                noDataError: ' Please click "+ Add RawMaterialProfit" to add a new RawMaterialProfit'
            },
            id: []
        }
    },
    watch: {

    },
    methods: {
        rawMaterialProfitAdd() {
            this.$router.push({
                name: 'rawMaterialProfitAdd'
            })
        },
        async tableIconAction (type, data, index = null) {
            this.id = this.structureReturnData(data)
            if (type === 'print') {
                PrintService.print('/print/raw-material-profit/' + data.id);
            } else if (type === 'edit') {
                const url = this.$router.resolve({
                    name: 'rawMaterialProfitEdit',
                    params: {id: data.id}
                }).href
                window.open(url, '_blank')
            } else if (type === 'delete') {
                this.deleteModal();
            }
        },
        async deleteModal() {
            const ok = await this.$refs.confirmDialogue.show({
                message: 'Are you sure you want to delete?',
                okButton: 'Delete',
            })
            if (ok) {
                this.delete()
            }
        },

        list: function (page) {
            if (page === undefined) {
                page = 1
            }
            this.param.page = page;
            this.table.loading = true
            ApiService.POST(ApiRoutes.RawMaterialProfit + '/list', this.param, (res) => {
                this.table.loading = false
                if (parseInt(res.status) === 200) {
                    this.table.rows = res.data.data;
                    this.table.paginateData = res.data;
                    this.table.total.amount = res.total;
                }
            });
        },
        delete: function () {
            ApiService.POST(ApiRoutes.RawMaterialProfit + '/delete', {id: this.id[0]}, (res) => {
                this.$refs.confirmDialogue._loading(false)
                if (parseInt(res.status) === 200) {
                    this.$toast.success(res.message)
                    this.$refs.confirmDialogue._hide()
                    this.list()
                }
            });
        },
        downloadFile: function (type) {
            let route = type === 'xls' ? ApiRoutes.EmployeeExportExcel : ApiRoutes.EmployeeExportPdf
            let name = type === 'xls' ? 'Employee List.xlsx' : 'Employee List.pdf'
            DownloadService.download(route, this.table.download, name, type, this.param)
        }
    },
    mounted() {
        this.list()
    },
    created() {
        this.breadCrumb.push(this.$route.name)
    }
}
</script>

<style scoped>

</style>
